import { IUser } from 'layouts/front-layout/interfaces';
import { UserTypes } from '../../core/auth/constants';
import localStorage from '../../core/local-storage/localStorage';

export const getAdminToolbarSettings = (
  user: IUser,
): { languages: string } | null => {
  if (user.type === UserTypes.USER) {
    return null;
  }

  return localStorage.get('admin-toolbar-settings') || null;
};
